module.exports = __webpack_public_path__ + "static/media/19.d78c5fb6.jpg";